"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var useDealStatusAssertion_1 = require("../../common/react/useDealStatusAssertion");
var JourneyTypes_1 = require("../../../../common/enum/JourneyTypes");
var MainHeaderWithBackLink_1 = require("../../common/components/presentation/MainHeader/MainHeaderWithBackLink");
var EnquiryForm_1 = require("../../enquiryForm/components/enquiryForm/EnquiryForm");
var EnquiryFormVehicleSummary_1 = require("../../enquiryForm/components/vehicleSummary/EnquiryFormVehicleSummary");
var ReserveOnline = function () {
    var _a;
    useDealStatusAssertion_1.default((_a = {},
        _a[JourneyTypes_1.JourneyTypes.RESERVE_ONLINE] = 3000,
        _a[JourneyTypes_1.JourneyTypes.CONTINUE_IN_DEALERSHIP] = false,
        _a[JourneyTypes_1.JourneyTypes.ORDER_ONLINE] = false,
        _a));
    return (<>
      <MainHeaderWithBackLink_1.default titleTranslation={'journeyType.checkoutReserveOnline'} withBackLink={true}/>
      <core_1.Container>
        <EnquiryFormVehicleSummary_1.default />
      </core_1.Container>

      <EnquiryForm_1.default journeyType={JourneyTypes_1.JourneyTypes.RESERVE_ONLINE}/>
    </>);
};
exports.default = ReserveOnline;
